import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import TeamIndia from './TeamIndia';
import TecCEM from './TecCEM';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const PartnershipLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#IntroMD') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
    } else if (key === '#FTMD') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#IntroMD' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2.4vh'}}>IISER TIRUPATI</Text></Content>}/>
          <Link href='#FTMD' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2.4vh'}}>TEC CEM</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> P&nbsp;<br/> A&nbsp;<br/> R&nbsp;<br/> T&nbsp;<br/> N&nbsp;<br/> E&nbsp;<br/> R&nbsp;<br/> S&nbsp;<br/> H&nbsp;<br/> I&nbsp;<br/> P&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='IntroMD'>
              <TeamIndia/>
            </div>
            <div id='FTMD'>
              <TecCEM/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default PartnershipLogic;
